module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "hlf"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('strong', [_vm._v("THE RECKONING")]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "hlf"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "id": "tit"
    }
  }), _c('strong', [_vm._v("THE RECKONING")])]), _vm._v(" "), _c('p', {
    staticClass: "tit1"
  }, [_c('strong', [_vm._v("DEBT, DEMOCRACY, AND THE FUTURE OF AMERICAN POWER")])]), _vm._v(" "), _c('p', {
    staticClass: "auth"
  }, [_c('strong', [_vm._v("MICHAEL MORAN")])]), _vm._v(" "), _c('p', {
    staticClass: "auth1"
  }, [_c('em', [_vm._v("Foreword by Dr. Nouriel Roubini")])]), _vm._v(" "), _c('p', {
    staticClass: "image-tit"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/title.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c0909ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780230339934_01_Prexiv.vue
// module id = 60
// module chunks = 0